import { createContext, useContext } from 'react'

/**
 * This context is used in index.js to let components deeper in the tree control the global page footer.
 * The context value is a function with siganture: setShowFooter(showFooter: boolean) => void
 * This is in a separate file to avoid a dependency cycle with index.js
 */
export const ConditionalFooterContext = createContext(null)

/**
 * Used by consumers to turn the global page footer on or off.
 * @returns {(showFooter: boolean) => void} - setShowFooter function
 */
export function useSetShowFooter() {
  const setShowFooter = useContext(ConditionalFooterContext)
  if (typeof setShowFooter !== 'function') {
    throw new Error('useSetShowFooter must be used within ConditionalFooterContext.Provider')
  }
  return setShowFooter
}
